<template>
<div class="chapter">
<div class="inner_page">
<p class="title-no1"><a id="page_5">CONTENTS</a></p><a id="page_5">
</a><p class="in-para"><a id="page_5"></a><span href="#/Title" title="Link target outside of Sample">Title Page</span></p>
<p class="in-para"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></p>
<p class="in-para"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></p>
<p class="in-para"><a href="#/Acknowledgments#Ack">Acknowledgments</a></p>
<p class="in-para"><a href="#/Introduction#Intro">Introduction</a></p>
<p class="in-para"><a href="#/Chapter1#C1">CHAPTER ONE</a>   <a href="#/Chapter1#C1">Superstars of Early Denton</a></p>
<p class="in-para"><span href="#/Chapter2#C2" title="Link target outside of Sample">CHAPTER TWO</span>   <span href="#/Chapter2#C2" title="Link target outside of Sample">Superstars of Business and Philanthropy</span></p>
<p class="in-para"><span href="#/Chapter3#C3" title="Link target outside of Sample">CHAPTER THREE</span>   <span href="#/Chapter3#C3" title="Link target outside of Sample">Superstars of Public, Political, and Military Service</span></p>
<p class="in-para"><span href="#/Chapter4#C4" title="Link target outside of Sample">CHAPTER FOUR</span>   <span href="#/Chapter4#C4" title="Link target outside of Sample">Superstars of the Arts</span></p>
<p class="in-para"><span href="#/Chapter5#C5" title="Link target outside of Sample">CHAPTER FIVE</span>   <span href="#/Chapter5#C5" title="Link target outside of Sample">Superstars of Education</span></p>
<p class="in-para"><span href="#/Chapter6#C6" title="Link target outside of Sample">CHAPTER SIX</span>   <span href="#/Chapter6#C6" title="Link target outside of Sample">Superstars of Athletics</span></p>
<p class="in-para"><span href="#/Chapter7#C7" title="Link target outside of Sample">CHAPTER SEVEN</span>   <span href="#/Chapter7#C7" title="Link target outside of Sample">Superstars of Space, Medicine, Technology, and Innovation</span></p>
<p class="in-para"><span href="#/Chapter8#C8" title="Link target outside of Sample">CHAPTER EIGHT</span>   <span href="#/Chapter8#C8" title="Link target outside of Sample">Superstars as Community Spirits and Civic Heroes</span></p>
<p class="in-para"><span href="#/Index#Ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0b8db22d